/**
 * Takes in any string and convert the first letter to uppercase and the rest in lowercase
 * @param value - string
 */
const capitalizeFirstLetter = (value) => {
    const valueInLowerCase = value.toLowerCase();
    return valueInLowerCase[0].toUpperCase() + valueInLowerCase.slice(1);
};
export default capitalizeFirstLetter;
